<template>
    <div v-if="permission && permission.version === '5'" class="fluid page_content pg_course_list">
        <div class="row page-heading pr-0">
            <div class="col-8 input module_heading" role="heading" aria-level="1">
                <span class="module_icon icon-course"></span>
                <span class="module_type_name" v-if="masterCourse">{{masterCourse.title}} - Sections</span>
            </div>
            <div class="col-4 submit btn-container text-right">
            </div>
        </div>

        <div class="course-management-section">
            <div class="page_subheading">
              <div class="course-list-left">
                  <label id="catalogTitle" class="head_txt module_type_name ace_sec_hd" role="heading" aria-label="Course Sections">
                    <b-form-select
                      v-model="currentGroup"
                      :options="groups"
                      class=""
                      value-field="name"
                      text-field="name"
                      disabled-field="notEnabled"
                      :title="currentGroup"
                    ></b-form-select>
                  </label>
                  <span class="selected-count ace_sec_txt">{{ selected.length }} / {{ totalElements }}</span>
                </div>
                <div class="toolbar-right ui-list-toolbar">
                    <select v-model="pageSize" @change="resetPage" aria-label="page size" class="page_size">
                        <option v-for="option in sizeOptions" v-bind:value="option">
                        {{ option }}
                        </option>
                    </select>
                    <div class="btn_container pagination_sty3">
                      <button type="button" :disabled="firstPage" v-on:click="prev" class="btn btn_trans" :title="$t('previousPage')" :aria-label="$t('previousPage')"><span class="ic2_arr_pre3" aria-hidden="true"></span></button>
                      <span class="page_count" aria-hidden="true">{{ page + 1  }}</span>
                      <button type="button" :disabled="lastPage" v-on:click="next" class="btn btn_trans" :title="$t('nextPage')" :aria-label="$t('nextPage')"><span class="ic2_arr_next3" aria-hidden="true"></span></button>
                    </div>
                </div>
            </div>
            <div class="course-management-table-container">
                <table v-if="isCoursesLoaded" class="table b-table table-bordered border">
                    <thead class="thead-light text-center">
                        <tr>
                          <th class="first-column">
                            <label class="form-checkbox">
                              <input type="checkbox" v-model="selectAll" @click="select" :disabled="(courses.length === 0) || permission.systemPermission.readOnly" aria-label="select all courses">
                              <i class="form-icon"></i>
                            </label>
                          </th>
                          <th class="second-column">Course Title</th>
                          <th class="third-column">Owner</th>
                          <th class="fourth-column">Folder</th>
                          <th class="last-column">Date Updated</th>
                          <th class="last-column">Flags</th>
                        </tr>
                    </thead>
                    <tbody v-if="courses.length > 0">
                        <tr v-for="course in courses">
                            <td class="first-column text-center">
                                <label class="form-checkbox">
                                    <input type="checkbox" :value="course.uuid" v-model="selected" :disabled="(courses.length === 0) || permission.systemPermission.readOnly" aria-label="select course">
                                    <i class="form-icon"></i>
                                </label>
                            </td>
                            <td class="second-column col_title">
                                <a href="javascript://" @click="goToCourseDashboard(course.uuid)">{{ course.title }}</a>
                                <template v-if="course.master">
                                  <span class="icon-master" title="Master Course" v-b-tooltip.hover>m</span>
                                </template>
                            </td>
                            <td class="third-column col_owner">{{ course.ownerName }}</td>
                            <td class="fourth-column col_lib">{{ course.owningLibraryName }}</td>
                            <td class="last-column col_date">{{ getFormattedDateTime(course.lastUpdatedTime) }}</td>
                            <td class="last-column col_date">
                              <div class="tags_row">
                                <span class="tag ir" v-if="course.sendItemAnalysisReportCourse" title="Item Analysis Report" v-b-tooltip.hover>
                                  <span class="tag_name ir">IR</span>
                                </span>
                                <span class="tag archive" v-if="course.archived" title="Hidden Course" v-b-tooltip.hover>
                                  <span class="tag_name archive">H</span>
                                </span>
                                <span class="tag ir" v-if="course.version === 'V2'" title="Modular Course" v-b-tooltip.hover>
                                  <span class="tag_name ir">Modular</span>
                                </span>
                                <span class="tag ir" v-else title="Traditional Course" v-b-tooltip.hover>
                                  <span class="tag_name ir">Traditional</span>
                                </span>

                              </div>
                            </td>
                        </tr>
                    </tbody>
                    <tbody v-else>
                        <tr>
                        	<td colspan="5" class="no-result" style="text-align: center;">No Results Found</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="loading-spinner">
            <b-modal style="padding: 0px;" ref="loadingModal" hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
                <div class="text-center" style="color: #FFF">
                    <i class="fa fa-spinner fa-3x fa-fw fa-pulse"></i>
                </div>
            </b-modal>
        </div>

    </div>

</template>

<script>
  import { mapActions, mapState } from 'vuex'
  import '../../../assets/module/css/course/courseList.min.css'
  export default {
    name: 'master-section-list',
    props: ['masterCourse', 'uuid'],
    data () {
      return {
        courses: [],
        currentGroup: "All Courses",
        groups: [{name:"All Courses"}, {name:"Active Courses"},{name:"Modular Courses"},{name:"Traditional Courses"},{name:"Hidden Courses"}, {name:"Item Report Enabled Courses"}],
        pageSize: 10,
        sizeOptions: [ 10, 50, 100 ],
        firstPage: true,
        lastPage: false,
        page: 0,
        totalElements: 0,
        name: '',
        archive: 'ALL',
        archiveFlag: false,
        archiveOrUnarhive : 'archive',
        airText : '',
        airFlag: false,
        itemReport: 'ALL',
        version: 'ALL',
        selected: [],
        selectAll: false,
        isCoursesLoaded: false,
        courseSearchBtnStatus: true,
        months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      }
    },

    mounted () {
      this.loadPermission().then(res => {
        this.$refs.loadingModal.show()
        setTimeout(() => {
          this.loadCourseList()
        }, 500)
      })
    },

    methods: {
      ...mapActions([
        'loadAllCourses',
        'deleteCourses',
        'archiveCourses',
        'airCourses',
        'loadPermission',
        'loadCourseInformation'
      ]),
      computeGroupToShow (){
        let current = this.currentGroup
        this.archive = 'ALL'
        this.itemReport = 'ALL'
        this.version = 'ALL'

        if(current === 'All Courses'){
            this.archive = 'ALL'
        }

        if(current === 'Hidden Courses'){
            this.archive = 'true'
        }
        if(current === 'Active Courses'){
            this.archive = 'false'
        }
        if(current === 'Item Report Enabled Courses'){
            this.itemReport = 'true'
        }
        if(current === 'Modular Courses'){
            this.version = 'V2'
        }
        if(current === 'Traditional Courses'){
            this.version = 'V1'
        }

        this.loadCourseList()
      },
      async loadCourseList () {
        this.$refs.loadingModal.show()
        if(!this.masterCourse){
        	this.masterCourse = await this.loadCourseInformation(this.uuid)
        }
        this.loadAllCourses({page: this.page, count: this.pageSize, title: this.name, archive: this.archive, itemReport:this.itemReport, version:this.version, masterCourseId:this.uuid}).then(result => {
          this.courses = result.content
          this.firstPage = result.first
          this.lastPage = result.last
          this.page = result.number
          this.totalElements = result.totalElements
          this.$refs.loadingModal.hide()
          this.isCoursesLoaded = true
          if (this.selectAll) {
            this.selected = []
            this.selectAll = false
          }
          this.$refs.loadingModal.hide()
        })
      },

      goToCourseDashboard (uuid) {
        this.$store.commit('LOAD_COURSE', {})
        this.$store.commit('LOAD_CLASS_SUMMARY', {})
        return this.$router.push({name: 'courseDashboardInstructor', params: { uuid: uuid }})
      },

      select () {
        this.selected = []
        if (!this.selectAll) {
          for (var i in this.courses) {
            this.selected.push(this.courses[i].uuid)
          }
        }
      },

      enableSearch () {
        if (this.name.length > 0) {
          this.courseSearchBtnStatus = false;
        } else {
          this.courseSearchBtnStatus = true;
        }
      },
      handleSearch() {
        this.loadCourseList()
      },

      resetPage () {
        this.page = 0
        this.loadCourseList()
      },

      prev () {
        this.page -= 1
        this.loadCourseList()
      },

      next () {
        this.page += 1
        this.loadCourseList()
      },

      getFormattedDateTime (timeInMillis) {
        if (timeInMillis === 0) {
          return 'N/A'
        }
        var d
        var str = ''
        d = new Date(timeInMillis)
        str += String(this.months[d.getMonth()])
        str += ' ' + d.getDate()
        str += ', ' + d.getFullYear()
        var amPm = ''
        var currHour = d.getHours()
        if (currHour < 12) {
          amPm = 'AM'
        } else {
          amPm = 'PM'
        }
        if (currHour === 0) {
          currHour = 12
        }
        if (currHour > 12) {
          currHour = currHour - 12
        }
        var currMin = d.getMinutes()
        currMin = currMin + ''
        if (currMin.length === 1) {
          currMin = '0' + currMin
        }
        str += ' ' + currHour
        str += ':' + currMin
        str += ' ' + amPm
        return str
      },
      uploadCourseClicked () {
        return this.$router.push({name: 'courseSectionUpload'})
      }
    },
    computed: {
      ...mapState({
        'permission': state => state.user.permission,
        'institution': state => state.institution.institution
      })
    },
    watch: {
    currentGroup (newCurrentGroup) {
        this.computeGroupToShow()
      }
    }

  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/app/course/components/MasterSectionList.vue